import { useStore } from '@/store';
import { useNavigation } from '@/hooks/useNavigation';
import {
  getMenusForUser,
  getSystemMenusForUser,
  updateMenus,
  updateSystemMenus,
} from '@/utils';

export function useInitialState() {
  function restoreUser() {
    const { changeCurrentUser } = useStore.getState();
    const userStr = localStorage.getItem('user');
    try {
      if (userStr) {
        const user = JSON.parse(userStr);
        changeCurrentUser(user);
      }
    } catch (e) {
      console.error(e);
    }
  }
  function restoreMenu() {
    const { navigate } = useNavigation();
    const { changeCurrentMenu } = useStore.getState();
    const menuStr = localStorage.getItem('menu');
    try {
      if (menuStr) {
        const menu = JSON.parse(menuStr);
        changeCurrentMenu(menu);

        const currentPath = window.location.pathname;
        const isOnLogin = currentPath.endsWith('login');
        const isUnderMenuPath =
          currentPath === menu.path || currentPath.startsWith(menu.path + '/');
        if (!isOnLogin && !isUnderMenuPath) {
          navigate(menu.path);
        }
      }
    } catch (e) {
      console.error(e);
    }
  }
  function restoreMenus() {
    const { changeCurrentMenus } = useStore.getState();
    const { currentUser } = useStore.getState();
    try {
      if (currentUser) {
        const menus = getMenusForUser(currentUser);
        if (menus.length > 0) {
          changeCurrentMenus(menus);
          updateMenus(menus);
        }
      } else {
        const menusStr = localStorage.getItem('menus');
        if (menusStr) {
          const menus = JSON.parse(menusStr);
          changeCurrentMenus(menus);
        }
      }
    } catch (e) {
      console.error(e);
    }
  }
  function restoreSystemMenus() {
    const { changeCurrentSystemMenus } = useStore.getState();
    const { currentUser } = useStore.getState();
    try {
      if (currentUser) {
        const systemMenus = getSystemMenusForUser(currentUser);
        if (systemMenus.length > 0) {
          changeCurrentSystemMenus(systemMenus);
          updateSystemMenus(systemMenus);
        }
      } else {
        const systemMenusStr = localStorage.getItem('systemMenus');
        if (systemMenusStr) {
          const systemMenus = JSON.parse(systemMenusStr);
          changeCurrentSystemMenus(systemMenus);
        }
      }
    } catch (e) {
      console.error(e);
    }
  }
  const initialState = {
    init() {
      restoreUser();
      restoreMenu();
      restoreMenus();
      restoreSystemMenus();
    },
  };
  return {
    initialState,
  };
}
